import React, { useState } from 'react'
import moment from 'moment'
import { truncate } from 'lodash-es'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { MdMoreVert } from 'react-icons/md'
import { FaHeart } from 'react-icons/fa'
import Modal from "reactstrap/lib/Modal"
import ModalHeader from "reactstrap/lib/ModalHeader"
import ModalBody from "reactstrap/lib/ModalBody"
import ModalFooter from "reactstrap/lib/ModalFooter"
import { Button } from "reactstrap"
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import {withTranslations} from "../decorators/with-translations";
import { useMutation } from '@apollo/react-hooks';
import { query as DIALOGUE_QUERY } from '../containers/dialogue-page';
import { query as TOPIC_QUERY } from '../containers/dialogue-page-topic';

const LIKE_COMMENT = gql`
  mutation LikeOrUnlikeDialogueComment(
    $surveyId: UUID!
    $commentId: UUID!
    $languageCode: String
  ) {
    likeOrUnlikeDialogueComment (
      surveyId: $surveyId
      commentId: $commentId
      languageCode: $languageCode
    ) {
      id
      likesCount
      text
      createdAt
      respondentColor
      hasLikeByThisRespondent
      replies {
        id
        likesCount
        text
        createdAt
        respondentColor
        hasLikeByThisRespondent
        isOwnedByThisRespondent
        authorRespondentId
      }
      isOwnedByThisRespondent
      authorRespondentId
    }
  }
`;

const DELETE_COMMENT = gql`
  mutation DeleteDialogueComment (
    $surveyId: UUID!
    $commentId: UUID!
    $languageCode: String
  ) {
    deleteDialogueComment(
      surveyId: $surveyId
      commentId: $commentId
      languageCode: $languageCode
    )
  }
`;

const mapStateToProps = ({ survey: { showYourResults } }) => {
  return {
    showYourResults
  };
};

const DialogueCommentBlock = ({
  i,
  reply,
  onReplyClick,
  likeComment,
  match,
  useTranslate,
  isAfterGameGuest,
  disableActions,
  showYourResults
}) => {

  const getHexColor = (str) => {
    let r = "#";
    for ( let i = 1, l = str.length; i <= l; ++i ) {
      if ( !isNaN(parseInt(str.substring(i-1, i),0))) {
        str = str.substring(i-1);
        r = r.concat(parseInt(str, 0).toString());
        str = str.substring( parseInt(str,0).toString().length);
        i = 1;
      }
    }
    return r.length > 6 ?  r.substring(0, 7) : "#FCD7C5";
  };

  const t = (phrase) => useTranslate(`discussion.${phrase}`);

  const commentLiked = i.hasLikeByThisRespondent;
  const ownComment = showYourResults ? i.isOwnedByThisRespondent : false;
  //const ownComment = i.isOwnedByThisRespondent;

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleMenu = () => setDropdownOpen(prevState => !prevState);

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);

  const { params: { surveyId, languageCode, topicId } } = match;

  const userColor = i.respondentColor ? i.respondentColor : getHexColor(i.authorRespondentId);

  const refetchVariables = {
    surveyId,
    languageCode
  };

  if (topicId) {
    refetchVariables.topicId = topicId;
  }

  const [deleteComment] = useMutation(
    DELETE_COMMENT,
    {
      refetchQueries: [{ query: topicId ? TOPIC_QUERY : DIALOGUE_QUERY, variables: refetchVariables }],
      awaitRefetchQueries: true
    }
  )

  const handleDelete = () => {
    const variables = {
      surveyId,
      languageCode,
      commentId: i.id,
    };

    return deleteComment({ variables })
      .then(() => {
        toggleModal()
      });

  }

  const handleLike = () => {
    // If the question is owned by the user. Prevents grqphql error.
    if (i.isOwnedByThisRespondent) {
      return null;
    }

    const variables = {
      surveyId,
      commentId: i.id,
      languageCode
    };

    return likeComment({ variables })
  }

  const RenderConfirmationModal = () => {
    return (
    <Modal isOpen={modal} toggle={toggleModal} className="confirmation-modal">
      <ModalHeader toggle={toggleModal}>{t("delete_answer_modal_header")}</ModalHeader>
      <ModalBody>
        {t("delete_answer_modal_content")}
      </ModalBody>
      <ModalFooter>
        <Button size="md" color="primary" onClick={handleDelete}>{t("delete_button")}</Button>
        <Button size="md" color="outline-gray" onClick={toggleModal}>{t("cancel_button")}</Button>
      </ModalFooter>
    </Modal>
    )
  }

  return (
    <div className={`comment-structure ${reply ? 'reply' : ''} ${ownComment ? 'owner' : ''} ${disableActions ? 'actions-disabled' : ''}`}>
      <div className="d-flex">
        <div className="user-avatar" style={{ backgroundColor: userColor }}>
          <svg width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.5 8.375C9.67383 8.375 11.4375 6.61133 11.4375 4.4375C11.4375 2.26367 9.67383 0.5 7.5 0.5C5.32617 0.5 3.5625 2.26367 3.5625 4.4375C3.5625 6.61133 5.32617 8.375 7.5 8.375ZM11 9.25H9.49336C8.88633 9.52891 8.21094 9.6875 7.5 9.6875C6.78906 9.6875 6.11641 9.52891 5.50664 9.25H4C2.0668 9.25 0.5 10.8168 0.5 12.75V13.1875C0.5 13.9121 1.08789 14.5 1.8125 14.5H13.1875C13.9121 14.5 14.5 13.9121 14.5 13.1875V12.75C14.5 10.8168 12.9332 9.25 11 9.25Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="user-comment">
          <div className="comment-info">
            <span className="user-name">{ownComment ? 'Me' : `Colleague ${truncate(i.authorRespondentId, { 'length': 8, 'omission': '' })}`}</span>
            <span className="comment-time"><span className="divider-bullet"/> {moment(moment.utc(i.createdAt)).local().fromNow()}</span>
          </div>
          <div className="comment-body">
            {i.text}
          </div>
          {!!Number(i.likesCount) &&
            <div className="comment-likes">
              <FaHeart/>
              <span className="amount">{i.likesCount}</span>
            </div>
          }
          {(ownComment && !disableActions) &&
            <div className="comment-owner-actions">
              <Dropdown isOpen={dropdownOpen} toggle={toggleMenu} className="owner-actions">
                <DropdownToggle className="toggle-menu">
                  <MdMoreVert/>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={toggleModal}>{t("delete_answer")}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          }
        </div>
      </div>
      {!disableActions &&
        <div className="comment-actions">
          {!ownComment && (
            <button
              className={`btn-like ${commentLiked ? 'liked' : ''} ${i.isOwnedByThisRespondent ? 'disabled' : ''}`}
              onClick={handleLike}
            >
              <FaHeart/>{t("support_button")}
            </button>
          )}
          <div>
            {!ownComment && <span className="divider-bullet"/>}
            <button
              className="btn-reply"
              onClick={onReplyClick}
            >
              {t("reply_button")}
            </button>
          </div>
        </div>
      }
      <RenderConfirmationModal/>
    </div>
  )
}

export default compose(
  withRouter,
  withTranslations,
  graphql(LIKE_COMMENT, { name: "likeComment" }),
  connect(mapStateToProps, null)
)(DialogueCommentBlock)



// WEBPACK FOOTER //
// ./src/components/dialogue-comment-block.js